const modalWidget = () => {
    const modals = document.querySelectorAll('.modal[data-modal]');
    const modalsOpeners = document.querySelectorAll('[data-modal-target]');
    const modalsClosers = document.querySelectorAll('.modalClose');

    const openRelatedModal = event => {
        event.preventDefault();
        event.stopPropagation();
        const relatedModalIdentifier = event.target.getAttribute('data-modal-target');
        [...modals].forEach(modal => {
            if (modal.getAttribute('data-modal') === relatedModalIdentifier) modal.classList.add('shown');
        });
    };

    const closeAllModals = event => {
        event.preventDefault();
        event.stopPropagation();
        [...modals].forEach(modal =>
            modal.classList.remove('shown'));
    };

    [...modalsOpeners].forEach(modalOpener =>
        modalOpener.addEventListener('click', openRelatedModal));

    [...modalsClosers].forEach(modalCloser =>
        modalCloser.addEventListener('click', closeAllModals));
};
modalWidget();
